export default __webpack_public_path__ + "static/media/refer_img.82c0973f.png";